    <template>
        <div class="sw-modal edit-form-component">
            <div class="sw-modal-content">
                <div class="row sw-modal-heading">
                    <div class="col"><h4>Edit Section</h4></div>
                </div>
                <ValidationObserver ref="sectionForm">
                    <div class="sw-modal-body">
                        <div class="row question">
                            <div class="col-12 question__question">
                                Type
                            </div>
                            <div class="col-12">
                                <select v-model="section.type" v-on:change="provideDefaultSectionHeadingIfBlank">
                                    <option value="stay-information">About the Trip</option>
                                    <option value="personal-information">Questions for each Guest</option>
                                    <option value="room-information">Questions about each Booked {{getUnitTypeForDisplay}}</option>
                                    <option value="terms-and-conditions">Terms & Conditions</option>
                                    <option value="general">Other</option>
                                </select>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                Heading for section
                            </div>
                            <div class="col-12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <input type="text" v-model="section.title" v-bind:placeholder="titlePlaceholder" class="short-question">
                                    <span class="text-error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                Introductory text (optional)
                                <markdown></markdown>
                                <variables v-bind:variables="variablesCopy" v-bind:obj="section" v-bind:propertyName="'introduction'" v-bind:inputTextArea="introductionInput"></variables>
                            </div>
                            <div class="col-12">
                                <textarea v-model="section.introduction" class="long-question"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="sw-modal-actions">
                        <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                            {{infoMessage}}
                        </div>
                        <div v-show="updating && !success">
                            <Spinner/>
                        </div>
                        <div class="row" v-show="!updating && !success">
                            <div class="col text-center">
                                <button class="btn btn-secondary" v-on:click="cancel">Cancel</button>
                                <button class="btn btn-primary" v-on:click="save">Save</button>
                            </div>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </div>
    </template>

<script>
    import { store, getters } from '../../store.js'

    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    import Spinner from '../Spinner.vue'
    import Markdown from '../Markdown.vue'
    import Variables from "../establishments/Variables.vue";

    export default {
        name: 'EditSection',
        components: {
            Spinner, Markdown, Variables, ValidationObserver, ValidationProvider
        },
        props: {
            formTemplateReference: String,
            section: Object,
            index: Number
        },
        data: function() {
            return {
                copy: {},
                titlePlaceholder: "",
                updating: false,
                error: false,
                success: false,
                infoMessage: "Info message",
            }
        },
        computed: {
            getUnitTypeForDisplay: function() {
                const category = getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
                let text = category.charAt(0).toUpperCase() + category.substr(1).toLowerCase();
                return text;
            },
        },
        methods: {
            provideDefaultSectionHeadingIfBlank: function() {
                if (typeof this.section.title === 'undefined' || this.section.title === "") {
                    switch (this.section.type) {
                        case 'stay-information':
                            this.titlePlaceholder = "Your Trip";
                            break;
                        case 'personal-information':
                            this.titlePlaceholder = "Guest information";
                            break;
                        case 'room-information':
                            this.titlePlaceholder = this.getUnitTypeForDisplay + " information";
                            break;
                        case 'terms-and-conditions':
                            this.titlePlaceholder = "Terms and Conditions";
                            break;
                        case 'general':
                            this.titlePlaceholder = "Other";
                            break;
                    }
                }
            },
            cancel: function() {
                console.log("cancel");
                this.section.title = this.copy.title;
                this.section.type = this.copy.type;
                this.section.introduction = this.copy.introduction;
                this.$root.$emit('finished-editing-section-or-question');
                // if this is a new, unsaved section, then cancelling should remove it
                if (typeof this.section.reference === 'undefined') {
                    this.$root.$emit('delete-section-from-form', this.formTemplateReference, this.index);
                }
            },
            save: function() {
                console.log("saving section");
                this.$refs.sectionForm.validate().then(success => {
                    console.log("Validated:" + success);
                    if (!success) {
                        return
                    }

                    this.error = false;

                    let body = {
                        type: this.section.type,
                        title: this.section.title,
                        introduction: this.section.introduction,
                    };

                    if (typeof this.section.reference === 'undefined') {
                        // adding a new section
                        this.updating = true;
                        this.infoMessage = "Creating section";
                        this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                            + '/form-templates/' + this.formTemplateReference
                            + "/section-templates/index/" + this.index, body
                        ).then(response => {
                            console.log("Section created:")
                            console.log(response);
                            this.section.reference = response.data.reference;
                            this.infoMessage = "Section created";
                            this.success = true;
                            setTimeout(() => {
                                this.updating = false;
                                this.$root.$emit('finished-editing-section-or-question');
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.updating = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error creating section";
                            }
                        });
                    } else {
                        // updating a section
                        this.updating = true;
                        this.infoMessage = "Saving section";
                        this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                            + '/form-templates/' + this.formTemplateReference
                            + "/section-templates/" + this.section.reference, body
                        ).then(response => {
                            console.log("Section updated:")
                            console.log(response);
                            this.infoMessage = "Section updated"
                            this.success = true;
                            setTimeout(() => {
                                this.updating = false;
                                this.$root.$emit('finished-editing-section-or-question');
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.updating = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error updating section";
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            this.copy.title = this.section.title;
            this.copy.type = this.section.type;
            this.copy.introduction = this.section.introduction;
            this.provideDefaultSectionHeadingIfBlank();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_form_component";
    @import "../../styles/components/question_answer";
</style>